import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Action, Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, pluck } from 'rxjs/operators';
import { CandidateExtraInfoService } from '@shared/services/candidate-extra-info.service';
import { CandidateExtraInfo } from '@shared/models/candidate-extra-info';
import {
  candidatesExtraInfoLoad,
  candidatesExtraInfoLoadFail,
  candidatesExtraInfoLoadSuccess,
} from '@modules/candidate-extra-info/store/candidate-extra-info.actions';

@Injectable()
export class CandidateExtraInfoEffects {
  load$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(candidatesExtraInfoLoad),
      pluck('candidateIds'),
      mergeMap((candidateIds) =>
        this.service.loadExtraInfoForCandidates(candidateIds).pipe(
          map((response: CandidateExtraInfo[]) =>
            candidatesExtraInfoLoadSuccess({ payload: response }),
          ),
          catchError((error) => of(candidatesExtraInfoLoadFail(error))),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private store: Store<{}>,
    private service: CandidateExtraInfoService,
  ) {}
}
